import CardFrameSurface from "./CardFrameSurface";

export default function StandardCard({ card }) {
    if (!card) return null;

    const longThreshold = 72;
    const extraLongThreshold = 130;

    const length = card.prompts?.en?.length || 0;
    const isLongPrompt = length > longThreshold;
    const isExtraLongPrompt = length > extraLongThreshold;

    const englishTextClass = isExtraLongPrompt
        ? "text-sm font-semibold text-gray-900"
        : isLongPrompt
            ? "text-sm font-semibold text-gray-900"
            : "text-lg font-semibold text-gray-900";

    const otherLangTextClass = isLongPrompt
        ? "text-xs text-gray-700"
        : "text-sm text-gray-700";

    const insetClass = isExtraLongPrompt ? "inset-11" : "inset-14";

    return (
        <CardFrameSurface className="mx-auto h-[480px] w-[320px]">
            {/* Content inside the frame */}
            <div className={`absolute ${insetClass} pb-18 flex flex-col rounded-lg`}>
                <div className="flex-1 overflow-y-auto space-y-3 text-center">
                    {/* English prompt */}
                    {card.prompts?.en && (
                        <p className={englishTextClass}>{card.prompts.en}</p>
                    )}
                    <div className="flex flex-col justify-center items-center space-y-1">
                        {/* Other languages */}
                        {card.prompts?.ko && (
                            <p className={otherLangTextClass}>{card.prompts.ko}</p>
                        )}
                        {card.prompts?.zh && (
                            <p className={otherLangTextClass}>{card.prompts.zh}</p>
                        )}
                        {card.prompts?.es && (
                            <p className="text-xs text-gray-700">{card.prompts.es}</p>
                        )}
                    </div>
                </div>
            </div>
        </CardFrameSurface>
    );
}
